export default {
  methods: {
    categoryLink(category) {
      return this.$utils.removeDoubleSlashes(process.env.APP_URL + '/categoria/' +  category.slug);
    }
  },
}